import PartnerLogo1 from "../assets/images/png/partner-logo/enugugovt.webp";
import PartnerLogo2 from "../assets/images/png/partner-logo/vfd.webp";
import PartnerLogo3 from "../assets/images/png/partner-logo/coronation.webp";
import PartnerLogo4 from "../assets/images/png/partner-logo/ekitigovt.webp";
import PartnerLogo5 from "../assets/images/png/partner-logo/bankly.webp";
import PartnerLogo6 from "../assets/images/png/partner-logo/sunflower-trust.png";
import PartnerLogo7 from "../assets/images/png/partner-logo/DMSI.png";
import PartnerLogo8 from "../assets/images/png/partner-logo/Diageo.svg.png";
import PartnerLogo9 from "../assets/images/png/partner-logo/keystone-bank.png";
import PartnerLogo10 from "../assets/images/png/partner-logo/ibedc.png";
import PartnerLogo11 from "../assets/images/png/partner-logo/Binance-logo.png";
import PartnerLogo12 from "../assets/images/png/partner-logo/soft-alliance.png";
import PartnerLogo13 from "../assets/images/png/partner-logo/Wema-Bank-Logo.png";
import PartnerLogo14 from "../assets/images/png/partner-logo/FrieslandCampina_logo.svg";
import PartnerLogo15 from "../assets/images/png/partner-logo/union.webp";
import PartnerLogo16 from "../assets/images/png/partner-logo/JCI.png";
import PartnerLogo17 from "../assets/images/png/partner-logo/boi-logo.png";
import PartnerLogo18 from "../assets/images/png/partner-logo/jnc.png";
import PartnerLogo19 from "../assets/images/png/partner-logo/gsk.png";

import LearningIcon from "../assets/images/svg/intensive-learning.svg";
import PersonIcon from "../assets/images/svg/person.svg";
import ClockIcon from "../assets/images/svg/clock.svg";

import VanguardLogo from "../assets/images/png/news/vanguard.svg";
import DialyPostLogo from "../assets/images/png/news/dailypost.png";

export const businessSuccessStories = [
  {
    id: 5,
    logo: PartnerLogo5,
    title: "Bankly",
    description: `
        We delivered a comprehensive Data Science training to Bankly, 
        enhancing the capabilities of their staff members. The training was 
        centered around Data Visualization and Data Engineering.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Data Analytics & Data Incubator)",
        value: "2",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "20",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "6 - 8 weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 6,
    logo: PartnerLogo6,
    title: "Sunflower Trust",
    description: `
    We formed a partnership with Sunflower Trust, an educational 
    institution located in Kenya, to provide training for a group of 100 girls.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Frontend Web Dev)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "105",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "7 months",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 7,
    logo: PartnerLogo7,
    title: "Digital Marketing Skill Institute",
    description: `
    We conducted project management training for DMSI staff, 
    aiming to develop and refine their leadership team's 
    project management skills.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Project Management)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "50",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "12 months",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 8,
    logo: PartnerLogo8,
    title: "DIAGEO",
    description: `
    We conducted an enterprise-level data science training 
    tailored for their leadership, management, and growth teams.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Data Analytics)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "16",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "7 weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 9,
    logo: PartnerLogo9,
    title: "Keystone Bank",
    description: `
    We provided data science training for a group of 30 members from their team.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Data Science)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "20",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "7 weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 1,
    logo: PartnerLogo1,
    title: "Enugu State SMEs Empowerment",
    description: `
    Enugu state government through the Enugu SME centre is addressing unemployment 
    by partnering with Utiva to run Human Capital Development programs for its 
    indigenes. We train the beneficiaries on Product Design and Programming. 
    Helping qualified talents 
    accelerate their growth and get better job placements with the technical skills. 
        `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Programming & Product Design)",
        value: "2",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "120",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "6 - 16 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 10,
    logo: PartnerLogo10,
    title: "IBEDC",
    description: `
    We conducted training on Power BI for a team of 20 individuals.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Power Bi)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "20",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "5 Days",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 11,
    logo: PartnerLogo11,
    title: "BINANCE",
    description: `
    Binance collaborated with Utiva to offer 1000 scholarship 
    opportunities for training in any of our programs.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Blockchain)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "1000+",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "6 Months - 1 year (2 months/batch)",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 12,
    logo: PartnerLogo12,
    title: "Soft Alliance",
    description: `
    We provided product management training for a team of 27 members.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Product Management)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "28",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "12 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 13,
    logo: PartnerLogo13,
    title: "Wema Bank",
    description: `
    We organized a data science training session for their team members,
     which took place at both their head office and the Purple Academy.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Product Management)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "25",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "10 Days",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 14,
    logo: PartnerLogo14,
    title: "FRIESLAND CAMPINA",
    description: `
    We provided training to their team in the field of Data Science
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Excel and Power Bi)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "157",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "3 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 15,
    logo: PartnerLogo15,
    title: "UNION BANK",
    description: `
    We spearheaded their digital transformation, encompassing 
    staff training in both product management and data science.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Data Science)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "10",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "5 Days",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 16,
    logo: PartnerLogo16,
    title: "Junior Chambers International",
    description: `
    We offer scholarships to select students, enabling them to acquire diverse 
    skills such as cloud computing, product management, and data security.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Product Design)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "25",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "6 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 17,
    logo: PartnerLogo17,
    title: "Bank of Industry",
    description: `
    We conducted comprehensive cybersecurity training for their team, 
    equipping them for an upcoming examination in the same domain.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Cloud)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "5",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "1 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 18,
    logo: PartnerLogo18,
    title: "JNC",
    description: `
    We provided training to their staff on both Power BI and Excel.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Excel & Powerbi)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "6",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "2 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 19,
    logo: PartnerLogo19,
    title: "GSK",
    description: `
    We conducted training sessions for their team in the areas 
    of project management, digital marketing, and product management.
            `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses (Product Management)",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "24",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "6 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 2,
    logo: PartnerLogo2,
    title: "VFD Group",
    description: `
    In the bid to fill their rising talent needs of Product Managers, VFD Group recruited 
    recent graduates and partnered with us to train them on the Product Accelerator 
    path. We also trained their senior team on Product leadership.
        `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses",
        value: "2",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "5",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "6 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 3,
    logo: PartnerLogo3,
    title: "Coronation",
    description: `
    In order to drive the most growth with analytics, Coronation Bank worked with Utiva 
    to train recent graduates on Data Science skills. The business case focuses were 
    on Customer Value Management, Product 
    Performance Management, Organisational performance, Forecasting, Planning and Strategy.
        `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "24",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "7 Weeks",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
  {
    id: 4,
    logo: PartnerLogo4,
    title: "Ekiti State x TechInsight",
    description: `
    Ekiti State government refreshed itself on the path to addressing unemployment 
    in the state with human capital development programs. We partnered with Tech Cabal 
    insight to train indigenes of Ekiti state in Full stack programming for the 
    tech skills training program 
    which will equip them with relevant skills needed to be employable by global standards
        `,
    stats: [
      {
        id: 1,
        icon: LearningIcon,
        name: "Courses",
        value: "1",
      },
      {
        id: 2,
        icon: PersonIcon,
        name: "No of people trained",
        value: "50",
      },
      {
        id: 3,
        icon: ClockIcon,
        name: "Duration",
        value: "4 months",
      },
    ],

    media: [
      {
        id: 1,
        logo: VanguardLogo,
        linkUrl: "/",
      },
      {
        id: 2,
        logo: DialyPostLogo,
        linkUrl: "/",
      },
    ],
  },
];
